import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { computed, Directive, inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { asapScheduler } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Directive()
export abstract class ResponsiveDirective {
  isDesktop: Signal<boolean> = computed(() => !this.isMobile() && !this.isTablet() && this.isBreakpointInitialized());
  isTabletOrDesktop: Signal<boolean> = computed(() => !this.isMobile() && this.isBreakpointInitialized());
  isMobileOrTablet: Signal<boolean> = computed(() => !this.isDesktop() && this.isBreakpointInitialized());
  private readonly breakpointObserver = inject(BreakpointObserver);
  // Breakpoint signal with debounce (Safari-friendly)
  private readonly breakpointState = toSignal(
    this.breakpointObserver
      .observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium])
      .pipe(debounceTime(1, asapScheduler)),
  );
  isBreakpointInitialized: Signal<boolean> = computed(() => this.breakpointState() !== undefined);
  isExtraSmall: Signal<boolean> = computed(() => this.breakpointState()?.breakpoints[Breakpoints.XSmall] ?? false);
  isMobile: Signal<boolean> = computed(() => this.isExtraSmall() && this.isBreakpointInitialized());
  isSmall: Signal<boolean> = computed(() => this.breakpointState()?.breakpoints[Breakpoints.Small] ?? false);
  isTablet: Signal<boolean> = computed(() => this.isSmall() && this.isBreakpointInitialized());
  isMedium: Signal<boolean> = computed(() => this.breakpointState()?.breakpoints[Breakpoints.Medium] ?? false);
  isGreaterThanMd: Signal<boolean> = computed(
    () => !this.isExtraSmall() && !this.isSmall() && !this.isMedium() && this.isBreakpointInitialized(),
  );
}
